import { CheckpointIProps } from '../types/types'

// A checkpoint matches when the filter is empty, or the name or cp code
// (displayId, e.g. "CP-9") contains the filter (case-insensitive).
const matchesCheckpoint = (d: CheckpointIProps, filter: string) => {
  const lowerFilter = filter.trim().toLocaleLowerCase()
  if (lowerFilter === '') return true
  return (
    !!d?.name?.toLocaleLowerCase()?.includes(lowerFilter) ||
    !!d?.displayId?.toLocaleLowerCase()?.includes(lowerFilter)
  )
}

export const getPlacedCheckpoints = (
  checkpoints: CheckpointIProps[],
  filter: string,
  floorId: string
) => {
  return checkpoints
    ?.filter((d) => matchesCheckpoint(d, filter))
    .filter((d) => d.isPlaced && d?.floor?.id === floorId)
}

export const getUnPlacedCheckpoints = (
  checkpoints: CheckpointIProps[],
  filter: string
) => {
  return checkpoints
    ?.filter((d) => matchesCheckpoint(d, filter))
    .filter((d) => !d.isPlaced)
    ?.sort(
      (a, b) =>
        new Date(b?.createdAt).valueOf() - new Date(a?.createdAt).valueOf()
    )
}
